import { createFileRoute } from '@tanstack/react-router';
import { ForecastOccurrenceForm } from '@/pages/forecast/occurrence/form';
import { PROTECTED, FORECAST } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${FORECAST}`;

export const Route = createFileRoute(
  '/protected/_layout/forecast/_layout/planning/$id'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: EditForecastOccurrenceModal,
});

function EditForecastOccurrenceModal() {
  const { id } = Route.useParams();
  return <ForecastOccurrenceForm id={id} returnUrl={RETURN_URL} />;
}
